<script setup>
import { LIBRARY_ROUTES } from '@utils/library-routes'

defineProps({
    // null = count not yet known (cold load) — the count line is hidden, never a false "0 mixes"
    count: { type: Number, default: null },
})
</script>

<template>
    <RouterLink
        class="card"
        :to="{ name: LIBRARY_ROUTES.mixes }"
    >
        <span class="tile">
            <BaseIcon
                class="heart"
                name="heart"
                filled
            />
        </span>
        <span class="meta">
            <span class="card-title">Your Mixes</span>
            <span
                v-if="count !== null"
                class="card-count"
            >{{ count }} {{ count === 1 ? 'mix' : 'mixes' }}</span>
        </span>
        <BaseIcon
            class="chevron"
            name="chevron-right"
        />
    </RouterLink>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.card {
    display: flex;
    gap: $s-s;
    align-items: center;
    padding: $s-s;
    margin-bottom: $s-l;
    text-decoration: none;
    border: 1px solid $c-text-tertiary;
    border-radius: $size-radius-artwork;

    &:hover,
    &:active {
        text-decoration: none;
    }
}

.tile {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4.6rem;
    height: 4.6rem;
    background: $c-highlight;
    border-radius: $size-radius-artwork;
}

.heart {
    width: 2rem;
    height: 2rem;   // BaseIcon svgs have no intrinsic size — omit height and they default to 150px
    fill: $c-white;
}

.meta {
    display: flex;
    flex-direction: column;
}

.card-title {
    font-weight: 700;
    color: $c-text-faded;
}

.card-count {
    font-size: 14px;
    color: $c-text-faded;
}

.chevron {
    width: 1rem;
    height: 1.4rem;   // icon-chevron-right viewBox is 12x16
    margin-left: auto;
    fill: $c-text-faded;
}
</style>
